module.exports = __webpack_public_path__ + "static/media/DrBinodMaitin.bd83a9ef.png";